import React from 'react';
import { MessagePopup } from 'com-gyf-webcore-userinterfacecomponents';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import 'rc-dialog/assets/bootstrap.css';

import FormaDePago from './FormaDePago.jsx'
import TarjetaTitular from './TarjetaTitular.jsx'
import Adicionales from './Adicionales.jsx'
import Footer from './Footer.jsx'
import Breadcrumb from '../../NuevaSolicitudAdministradora/components/MarcaBreadcrumb.jsx';
import ClienteTitle from '../../NuevaSolicitudAdministradora/components/ClienteTitle.jsx';
import ModalDefecto from "../../../Common/Components/ModalDefecto.jsx"


//CABAL//
import DatosGeneralesCabal from './Cabal/DatosGeneralesCuenta.jsx'
import EmisionCabal from './Cabal/Emision.jsx'
import CorrespondenciaYContactoCabal from './Cabal/CorrespondenciaYContacto.jsx'
import FacturacionCabal from './Cabal/Facturacion.jsx'
import LimitesCabal from './Cabal/Limites.jsx'

//VISA//
import DatosGeneralesVisa from './Visa/DatosGeneralesCuenta.jsx'
import EmisionVisa from './Visa/Emision.jsx'
import CorrespondenciaYcontactoVisa from './Visa/CorrespondenciaYContacto.jsx'
import FacturacionVisa from './Visa/Facturacion.jsx'
import LimitesVisa from './Visa/Limites.jsx'

import NuevaSolicitudDatos from '../../NuevaSolicitudDatos/components/Container.jsx'
import DatosIncorrectos from '../../NuevaSolicitudDatos/components/DatosIncorrectos.jsx'

class NuevaSolicitud extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            breadcrumb: [],
            OpenModal: false,
            redirect: false
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.aceptModalCuentas = this.aceptModalCuentas.bind(this);
        this.redirectDatosCorrectos = this.redirectDatosCorrectos.bind(this);
        this.redirectDatosCorrectosEmpresa = this.redirectDatosCorrectosEmpresa.bind(this);
        this.toggleModalNo = this.toggleModalNo.bind(this);
    }

    componentDidMount(){
        let admin = this.props.tarjetas.administradora.Id ? this.props.tarjetas.administradora.Id : this.props.tarjetas.administradoraId;
        let tipoEmp = this.props.tarjetas.tipoEmpresa.EmpresaIndividuos ? this.props.tarjetas.tipoEmpresa.EmpresaIndividuos :"I";
        let tipoDeCuenta = this.props.tarjetas.tipoEmpresa.Descripcion;

        this.props.cargarDatosPantalla(this.props.currentScope);
        this.breadcrumbGenerator(admin,tipoEmp,tipoDeCuenta,this.props.tarjetas.empresaVisaSeleccionada);
        this.props.backAdicionales();
    }
    
    componentWillUnmount() {
        this.props.reiniciarStateCuenta();
    }


    toggleModal() {
        $('#SolicitudAltaDeCuenta').modal('toggle');
    }
    
    toggleModalNo() {
        this.props.confirmarClienteTarjeta(false);
    }

    aceptModalCuentas() {
        $('#datosIncorrectos').modal('toggle');
    }

    redirectDatosCorrectos() {
        this.props.confirmarClienteTarjeta(true);
        this.setState({ redirect: true })
    }

    redirectDatosCorrectosEmpresa() {
        this.setState({ redirect: true })
    }

    redirect = (closePopUp) => {
        closePopUp();
        this.setState({ redirectCancel: true });
    }
    

    render() {
        const { data, selectCombo, tarjetas, onBlurTextBox, tipoEmpresa, radioMonedaSelected, validateCuenta, correspondenciaModo, guardarBorrador, selectCheckBox, changeInput, loadDataFromTarjetas, volverASolicitudNSC, routeToNuevaSolicitudTipoEmpresa, routeToVistaCliente, selectSucursal } = this.props;
        const administradoraId = tarjetas.administradora.Id ? tarjetas.administradora.Id : tarjetas.administradora ;

        let productoSeleccionado = {}
        let productoDefault
        let spinner = null;
        let DatosGenerales = null;
        let Emision = null;
        let CorrespondenciaYcontacto = null;
        let Facturacion = null;
        let Limites = null;
        let modalAnterior = null;
        let modalCancel = null;
        let modalsolicitudGuardada = null;
        
        let productoSelected =  (productoId)=>{
            
            if(!this.props.data.isFetching && !this.props.data.datosGeneralesModificacion){
                this.props.productoSelected(productoId);
                this.props.retrievingProductData(true);
            }
        }

        if( data.GET_PRODUCTO_CABAL_PRODUCTO_ID ){
            productoSeleccionado = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
            productoDefault = data.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO
            
        }else if(data.GET_PRODUCTO_VISA_PRODUCTO_ID){
            productoSeleccionado = data.GET_PRODUCTO_VISA_PRODUCTO_ID
            productoDefault = data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO
        }

        if (data && data.isFetching == true)
            spinner = <div className="loading" />

        if (this.state.redirect == true && (((this.props.tarjetas.clienteTarjeta && this.props.tarjetas.clienteTarjeta.confirmado == true) || data.cuentasAdicionales)||tarjetas.tipoEmpresa.EmpresaIndividuos == "E") ) {
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudCuenta", "ROUTE_TO_NUEVA_SOLICITUD_ADICIONAL")} push />
        } 


        modalAnterior = <ModalDefecto
            id={"AnteriorCuenta"}
            titulo={"Importante"}
            mensaje={"Si retrocede se perderán los datos ingresados para la presente solicitud."}
            routeDesde={"NuevaSolicitudCuenta"}
            routeHasta={tarjetas.tipoEmpresa.EmpresaIndividuos == "I" ? "ROUTE_TO_TIPO_EMPRESA" : "ROUTE_TO_EMPRESA"}
        />

        modalCancel = <ModalDefecto
            id={"CancelCuenta"}
            titulo={"Cancelar Solicitud"}
            mensaje={"¿Desea cancelar la solicitud y volver a la pantalla principal?."}
            routeDesde={"NuevaSolicitudCuenta"}
            routeHasta={"ROUTE_TO_VISTA_CLIENTE"}

        
        />

        modalsolicitudGuardada = <ModalDefecto
            id={"solicitudGuardada"}
            titulo={"Solicitud Guardada"}
            mensaje={"Se registró la solicitud correctamente."}
            routeDesde={"NuevaSolicitudCuenta"}
            routeHasta={"ROUTE_TO_VISTA_CLIENTE"}
            soloAceptar={true}
            autoFoco={true}
        />

        if(tarjetas.solicitudCuenta){
            switch ( administradoraId ) {
                case 1:
                    DatosGenerales = <DatosGeneralesVisa cargarDatosModificacion={this.props.cargarDatosModificacion} cargarDatosPantalla={this.props.cargarDatosPantalla} currentScope={this.props.currentScope} selectSucursal={selectSucursal} volverASolicitudNSC={volverASolicitudNSC} tarjetas={tarjetas} loadDataFromTarjetas={loadDataFromTarjetas} selectCheckBox={selectCheckBox} seleccionarPromotor={this.props.seleccionarPromotor} productoSelected={productoSelected} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} />
                    Emision = <EmisionVisa cargarDatosModificacion={this.props.cargarDatosModificacion} tarjetas={tarjetas} cuotasTarjetas={tarjetas.solicitudCuenta.cuotasCostoEmisionSeleccionadas} porcentajeTarjetas={tarjetas.solicitudCuenta.porcentajeCostoEmision} tipoDeCuenta={tipoEmpresa} data={data} changeInput={changeInput}/>
                    CorrespondenciaYcontacto = <CorrespondenciaYcontactoVisa cargarDatosModificacion ={this.props.cargarDatosModificacion } selectDomicilioVisa={this.props.selectDomicilioVisa} flagDatosModificacionCargados={this.props.flagDatosModificacionCargados} tarjetas={tarjetas} correspondenciaModo={correspondenciaModo} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} />
                    Facturacion = <FacturacionVisa cargarDatosModificacion={this.props.cargarDatosModificacion} tarjetas={tarjetas} data={data} selectCombo={selectCombo} tipoEmpresa={tipoEmpresa} onBlurTextBox={onBlurTextBox} ERROR_CUENTA={data.ERROR_CUENTA}/>
                    Limites = <LimitesVisa cargarDatosModificacion={this.props.cargarDatosModificacion} data={data} tarjetas={tarjetas} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} radioMonedaSelected={radioMonedaSelected}/>
                    break;
                case 2:
                    DatosGenerales = <DatosGeneralesCabal  cargarDatosModificacion={this.props.cargarDatosModificacion} selectSucursal={selectSucursal} volverASolicitudNSC={volverASolicitudNSC} tarjetas={tarjetas} loadDataFromTarjetas={loadDataFromTarjetas} selectCheckBox={selectCheckBox} seleccionarPromotor={this.props.seleccionarPromotor} productoSelected={productoSelected} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} />
                    CorrespondenciaYcontacto = <CorrespondenciaYContactoCabal cargarDatosModificacion ={this.props.cargarDatosModificacion } tarjetas={tarjetas} correspondenciaModo={correspondenciaModo} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} />
                    Emision = <EmisionCabal tarjetas={tarjetas} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} />
                    Facturacion = <FacturacionCabal cargarDatosModificacion={this.props.cargarDatosModificacion} productoDefault={productoDefault && productoDefault} producto={productoSeleccionado && productoSeleccionado} tarjetas={tarjetas} data={data} selectCombo={selectCombo} onBlurTextBox={onBlurTextBox} ERROR_CUENTA={data.ERROR_CUENTA}  />
                    Limites = <LimitesCabal cargarDatosModificacion={this.props.cargarDatosModificacion} tarjetas={tarjetas} dataTarjetas={tarjetas.solicitudCuenta} parametros={data.GET_ATLAS_PARAMETRO_GENERAL} producto={productoSeleccionado} onBlurTextBox={onBlurTextBox} productoDefault = {productoDefault} data={data}/>
                    break;
            }
        }

        let existeProducto = (data.GET_PRODUCTO_VISA_PRODUCTO_ID || data.GET_PRODUCTO_CABAL_PRODUCTO_ID)
        
        return (
            <div>

                {modalAnterior}

                {modalCancel}

                {modalsolicitudGuardada}

                {spinner}

                <DatosIncorrectos onclick={this.aceptmodalcuentas}/>

                <MessagePopup isHidden={data.messageHidden}
                    message={data.message}
                    classMessage={data.messageClass} />

                <div className="row">
                    <div className="col-md-12">
                        <ClienteTitle className="breadcrumb"
                            cliente={this.props.tarjetas.clienteResultadoBusqueda}
                            empresas={null}
                            novedadesempresas={null}
                            esModificacion={tarjetas.esModificacion} />
                    </div>
                </div>

                    {<Breadcrumb className="breadcrumb"
                        currentScreen={null}
                        menu={this.state.breadcrumb}
                        product={null}
                        module={null} />}

                <div className="datos-cuenta">               
                    {DatosGenerales}
                    {CorrespondenciaYcontacto}
                    {Emision}
                    {Limites}
                    {Facturacion }
                    {existeProducto &&<FormaDePago data={data} tarjetas={tarjetas} selectCombo={selectCombo} ERROR_CUENTA={data.ERROR_CUENTA}/>} 
                    {tarjetas.tipoEmpresa.EmpresaIndividuos == "I" && <TarjetaTitular cargarAdicionalesModificacion={this.props.cargarAdicionalesModificacion} cargarDatosModificacion={this.props.cargarDatosModificacion} data={data} selectCombo={selectCombo} tarjetas={tarjetas} onBlurTextBox={onBlurTextBox}/>}
                    <Adicionales confirmarClienteTarjeta={this.props.confirmarClienteTarjeta}  cargarAdicionalesModificacion={this.props.cargarAdicionalesModificacion}  cargarDatosModificacion={this.props.cargarDatosModificacion}toggleModal={this.toggleModal} buscarPorCuit={this.props.buscarPorCuit} pantallaActual="NuevaSolicitudCuenta" tarjetas={tarjetas} data={data} onBlurTextBox={onBlurTextBox}/>     
                </div>   

                {<NuevaSolicitudDatos
                    administradora="VISA"
                    cliente={tarjetas.clienteTarjeta}
                    esAdicional={true}
                    toggleModal={this.toggleModal}
                    aceptModalCuentas={this.aceptModalCuentas}
                    redirect={this.redirectDatosCorrectos}
                    callback={this.toggleModalNo}
                />} 

                <Footer data={data}
                    screen={"NuevaSolicitudCuenta"}
                    routeToBack={"ROUTE_TO_TIPO_EMPRESA"}
                    routeToNext={""}
                    validate={validateCuenta}
                    guardarBorrador={guardarBorrador}
                    redirectAdicionales={this.redirectDatosCorrectos}
                    redirectAdicionalesEmpresa={this.redirectDatosCorrectosEmpresa}
                    routeToVistaCliente={routeToVistaCliente}
                    routeToNuevaSolicitudTipoEmpresa={routeToNuevaSolicitudTipoEmpresa}
                    tarjetas={tarjetas}
                    hideAceptar={data.hideAceptar == true}
                />
            </div>
            )
    }
    
    breadcrumbGenerator(idAdm,letraFiltro,tipoDeCuenta,empresa) {
        let nuevaSolicitudMap = [];
        if ( letraFiltro == "I" ) {
                nuevaSolicitudMap.push( { descripcion: idAdm ==1 ? "VISA": "CABAL", ruta: "", activo: false, normal: true, anterior: true } );
                nuevaSolicitudMap.push( { descripcion: tipoDeCuenta, ruta: "", activo: false, normal: true, anterior: true } );
                nuevaSolicitudMap.push( { descripcion: "Datos de la Cuenta", ruta: "", activo: true, normal: false, anterior: false } );
                nuevaSolicitudMap.push({ funcion: this.redirectDatosCorrectos, descripcion: "Adicionales", ruta: "", activo: false, normal: true, anterior: false });
        } else if (letraFiltro == "E") {
            if (idAdm == 1) {
                nuevaSolicitudMap.push({ descripcion: idAdm ==1 ? "VISA": "CABAL", ruta: "", activo: false, normal: true, anterior: true });
                nuevaSolicitudMap.push({ descripcion: tipoDeCuenta, ruta: "", activo: false, normal: true, anterior: true });
                nuevaSolicitudMap.push({ descripcion: empresa.Descripcion, ruta: "", activo: false, normal: true, anterior: true });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: true, normal: false, anterior: false });
                nuevaSolicitudMap.push({ funcion: this.redirectDatosCorrectos, descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });
            } else if (idAdm == 2) {
                nuevaSolicitudMap.push({ descripcion: idAdm ==1 ? "VISA": "CABAL", ruta: "", activo: false, normal: true, anterior: false, anterior: true });
                nuevaSolicitudMap.push({ descripcion: tipoDeCuenta, ruta: "", activo: false, normal: true, anterior: true });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: true, normal: false, anterior: false });
                nuevaSolicitudMap.push({ funcion: this.redirectDatosCorrectos, descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });
            }
        }
        this.setState({ breadcrumb: nuevaSolicitudMap })
    }

}

export default NuevaSolicitud;



